import { useEffect, useState } from "react";
import axios from "axios";
import swal from 'sweetalert';

const CustomerCardComponent = ({ cardParam, indexa, triggerLoop, classes = "" }) => {
    const [expand, setExpand] = useState(false);
    const card = cardParam;

    const makeCardPrimary = (id) => {
        axios.post('customer-card-primary/' + id)
            .then((res) => {
                if (res.status == 200) {
                    swal('Customer card has been set primary!', {
                        icon: "success",
                    });
                    triggerLoop(id);
                }
            }).catch(function (error) {
                console.log(error);
            });
    }

    const deleteCard = (id) => {
        swal({
            title: "Are you sure?",
            text: 'You want to delete this card?',
            icon: "warning",
            buttons: true,
            dangerMode: true,
            confirm: {
                text: "Yes",
                value: true,
                visible: true,
                className: "",
                closeModal: true
            }
        }).then((result) => {
            if (result == true) {
                axios.delete('cards/' + id).then(function (res) {
                    console.log(res);
                    if (res.status == 200) {
                        swal('The card has been deleted!', {
                            icon: "success",
                        });
                        triggerLoop(id);
                        return true;
                    } else {
                        return false;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }
        });
    }

    return (
        <>
            <div key={indexa} className={`mb-10${classes ? " " + classes : ''}`}>
                {/* {!card?.is_default &&
                    (
                        <div className="customer-address-edit-btn-div edit">
                            <i
                                className="fas fa-shield-alt d-inline fs-3"
                                title="Make Primary"
                                onClick={() => {
                                    makeCardPrimary(card?.id);
                                }}
                            ></i>
                        </div>
                    )
                } */}
                {/* <div className="customer-address-edit-btn-div">
                    <i
                        className="far fa-trash-alt d-inline fs-3"
                        title="Delete"
                        onClick={() => {
                            deleteCard(card.id);
                        }}
                    >
                    </i>
                </div> */}
                <div className="card address p-8 pb-5 pt-10">
                    <h5 className="d-block">
                        <div className="d-inline-block py-2 fw-bolder fs-6 ls-1 user-select-none">
                            {card?.type}
                        </div>
                        {card?.is_default &&
                            (<span
                                className="badge badge-light-primary d-inline-block ml-3 py-2 fw-bolder fs-8 ls-1 user-select-none">
                                <i className="fas fa-star mr-2 color-primary"></i>
                                Primary
                            </span>)
                        }
                        <div
                            className="d-inline-block bg-secndary py-2 cursor-pointer float-right"
                            onClick={() => { setExpand(!expand) }}
                            title={expand ? "" : "Expand"}
                        >
                            <i className={`fas fa-chevron-${expand ? "up" : "down"} text-secondary fs-1 t-1-rem`}></i>
                        </div>

                        <div className="fw-bolder ls-1 mb-2 mt-7 color-dark-grey mr-3">
                            Number: <span className="fw-light">{card?.mask}</span>
                        </div>
                        <div className={`accordeon-div color-dark-grey pt-3${expand ? "" : " d-none"}`}>
                            <div className="fw-bolder ls-1 mb-2 mt-3">
                                id:
                            </div>
                            <div className="fw-normal ls-1 mb-7">
                                {card?.id}
                            </div>
                            <div className="fw-bolder ls-1 mb-2">
                                Add Date:
                            </div>
                            <div className="fw-normal ls-1 mb-7">
                                {new Date(card?.add_date).toLocaleDateString('en-GB')}
                            </div>
                        </div>
                    </h5>
                </div>
            </div>
        </>
    )
}

export default CustomerCardComponent;